import { Input } from "@/core/components/ui/input";
import { Label } from "@/core/components/ui/label";
import { useAdminTranslation } from "@/features/admin/i18n/use-admin-translation";

export interface AuditLogsFiltersValue {
  sourceService?: string;
  resourceType?: string;
  resourceId?: string;
  actorKeycloakId?: string;
}

/**
 * Barre de filtres du journal d'audit (`POST /AuditLogs/all` — champs du
 * `AuditLogFilter`, §6.8). Chaînes libres transmises telles quelles à
 * l'API ; une valeur vide retire le filtre.
 */
export function AuditLogsFilters({
  value,
  onChange,
}: {
  value: AuditLogsFiltersValue;
  onChange: (value: AuditLogsFiltersValue) => void;
}) {
  const { t } = useAdminTranslation();

  const set = (patch: Partial<AuditLogsFiltersValue>) =>
    onChange({ ...value, ...patch });

  const textFilter = (
    id: keyof AuditLogsFiltersValue,
    labelKey: string,
    placeholderKey: string,
    widthClass = "w-64"
  ) => (
    <div className="space-y-1.5">
      <Label htmlFor={`audit-${id}`}>{t(labelKey)}</Label>
      <Input
        id={`audit-${id}`}
        value={value[id] ?? ""}
        placeholder={t(placeholderKey)}
        className={`${widthClass} font-mono`}
        onChange={(e) =>
          set({ [id]: e.target.value ? e.target.value : undefined })
        }
      />
    </div>
  );

  return (
    <div className="flex flex-wrap items-end gap-4">
      {textFilter(
        "sourceService",
        "admin.audit.filters.sourceService",
        "admin.audit.filters.sourceServicePlaceholder"
      )}
      {textFilter(
        "resourceType",
        "admin.audit.filters.resourceType",
        "admin.audit.filters.resourceTypePlaceholder",
        "w-48"
      )}
      {textFilter(
        "resourceId",
        "admin.audit.filters.resourceId",
        "admin.audit.filters.resourceIdPlaceholder"
      )}
      {textFilter(
        "actorKeycloakId",
        "admin.audit.filters.actor",
        "admin.audit.filters.actorPlaceholder"
      )}
    </div>
  );
}
